
import { useNavigate } from 'react-router-dom';

export function DestinationsSection() {
  const navigate = useNavigate();
  const destinations = [
    {
      title: "Around Lamu Island, Kenya",
      duration: "09 Night / 10 Days",
      description: [
        "UNESCO-listed Swahili settlement with car-free streets, dhows, and centuries-old architecture.",
        "Ideal for cultural exploration and laid-back coastal escapes."
      ],
      image: "/images/africa-dest-1.jpg",
      alt: "Lamu Island Kenya",
      reverse: false
    },
    {
      title: "NamibRand Nature Reserve, Namibia",
      duration: "09 Night / 10 Days",
      description: [
        "A private desert reserve with dramatic dunes, starry skies, and surreal landscapes.",
        "Perfect for eco-luxury desert safaris."
      ],
      image: "/images/africa-dest-2.jpg",
      alt: "NamibRand Nature Reserve",
      reverse: true
    },
    {
      title: "Around São Tomé & Príncipe",
      duration: "11 Night / 12 Days",
      description: [
        "Remote volcanic islands with lush rainforests, cocoa plantations, and pristine beaches.",
        "Great for eco-tourism and untouched island charm."
      ],
      image: "/images/africa-dest-3.jpg",
      alt: "São Tomé & Príncipe",
      reverse: false
    },
    {
      title: "Around Makgadikgadi Pans, Botswana",
      duration: "12 Night / 13 Days",
      description: [
        "Vast salt flats that transform with seasonal rains into wildlife havens.",
        "Ideal for adventure seekers and stargazing experiences."
      ],
      image: "/images/africa-dest-4.jpg",
      alt: "Makgadikgadi Pans Botswana",
      reverse: true
    },
    {
      title: "Around Bazaruto Archipelago, Mozambique",
      duration: "12 Night / 13 Days",
      description: [
        "Turquoise waters, coral reefs, and luxurious island lodges.",
        "A niche alternative to Maldives-style beach escapes."
      ],
      image: "/images/africa-dest-5.jpg",
      alt: "Bazaruto Archipelago",
      reverse: false
    },
    {
      title: "Simien Mountains, Ethiopia",
      duration: "12 Night / 13 Days",
      description: [
        "UNESCO World Heritage site with dramatic cliffs, endemic wildlife, and trekking routes.",
        "Perfect for hikers and culture lovers."
      ],
      image: "/images/africa-dest-6.jpg",
      alt: "Simien Mountains Ethiopia",
      reverse: true
    },
    {
      title: "Loango National Park, Gabon",
      duration: "07 Night / 08 Days",
      description: [
        "Known as \"Africa's Last Eden\" with elephants, hippos, and gorillas roaming along wild beaches.",
        "Ideal for unique safari-meets-ocean experiences."
      ],
      image: "/images/africa-dest-7.jpg",
      alt: "Loango National Park Gabon",
      reverse: false
    },
    {
      title: "Fish River Canyon, Namibia",
      duration: "09 Night / 10 Days",
      description: [
        "Second-largest canyon in the world, offering breathtaking hikes and desert vistas.",
        "A haven for adventure and photography enthusiasts."
      ],
      image: "/images/africa-dest-8.jpg",
      alt: "Fish River Canyon Namibia",
      reverse: true
    },
    {
      title: "Discoveries of Mafia Island, Tanzania",
      duration: "09 Night / 10 Days",
      description: [
        "Quieter than Zanzibar, offering whale shark diving, marine reserves, and rustic charm.",
        "Great for niche marine lovers and intimate escapes."
      ],
      image: "/images/africa-dest-9.jpg",
      alt: "Mafia Island Tanzania",
      reverse: false
    },
    {
      title: "Omo Valley, Ethiopia",
      duration: "10 Night / 11 Days",
      description: [
        "A living cultural museum with diverse tribal communities and vibrant traditions.",
        "Best for immersive cultural experiences."
      ],
      image: "/images/africa-dest-10.jpg",
      alt: "Omo Valley Ethiopia",
      reverse: true
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            All of Africa's Most Popular Destinations
          </h2>
        </div>

        <div className="space-y-20">
          {destinations.map((destination, index) => (
            <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${destination.reverse ? 'lg:flex-row-reverse' : ''}`}>
              <div className="lg:w-1/2">
                <img
                  src={destination.image}
                  alt={destination.alt}
                  className="w-full h-80 lg:h-96 object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="lg:w-1/2 space-y-6">
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900">
                  {destination.title}
                </h3>
                <p className="text-lg text-emerald-600 font-medium">
                  {destination.duration}
                </p>
                <ul className="space-y-3">
                  {destination.description.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 leading-relaxed">{item}</p>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => navigate(`/contact?subject=${encodeURIComponent('Enquiry about ' + destination.title)}`)}
                  className="inline-flex items-center gap-2 bg-emerald-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Enquire Now
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
